import React from "react";
import CopyRight from "./CopyRight";



function IsFirstTime() {
  const isFirstTimeVisit = localStorage.getItem("@isAppFirstTimeRunning");
  if (isFirstTimeVisit) {
  } else {
    localStorage.setItem("@isAppFirstTimeRunning", "true");
  }

  return (
    <div>
      {/* {isFirstTimeVisit && <h2>You have</h2>} */}
    </div>
  );
}

function Footer() {
  return (
    <>
      <footer>
        <IsFirstTime />
        <CopyRight />
      </footer>
    </>
  );
}

export default Footer;
